// extracted by mini-css-extract-plugin
export var calendarView = "_m2-0";